import moment from "moment";

/**
 * Login controller
 */
class LoginController {
	constructor(recoveryPasswordService, $scope, $location, $uibModal, $state) {
		'ngInject';

		//Exposing globals to another methods
		setTimeout(() => this.renderTurnstile(), 100);
		this.recoveryPasswordService = recoveryPasswordService;
		this.$scope = $scope;
		this.$uibModal = $uibModal;
		this.$state = $state;

		this.bdPickerOpen = false;
		this.bdDateOptions = {
			dateDisabled: false,
			formatYear: 'yy',
			maxDate: new Date(),
			startingDay: 1
		};

		this.loading = false;
		this.automateTest = !!$location.search().automateTest;
		this.captchaToken = null;

		sessionStorage.removeItem('deviceInfos');

	};

	/**
	 * Open or close birthday date picker popup
	 */
	toggleBDPicker = () => {
		this.bdPickerOpen = !this.bdPickerOpen;
	};

	/**
	 * Get validated user inputs and initialize the process of password recovery
	 */
	async initPasswordRecoveryProcess() {

		sessionStorage.removeItem('showIdentityQuestion');

		if (this.$scope.form.$invalid) {
			return;
		}

		this.loading = true;

		let result;
		let personalDataAsString = {...this.personalData};

		let data = personalDataAsString.birthday;
		data.setTime(data.getTime() + (3*60*60*1000));

		personalDataAsString.birthday = moment(data).format("YYYY-MM-DD");
		personalDataAsString['captchaToken'] = this.captchaToken;
		
		result = await this.recoveryPasswordService.initRecoverPasswordProcess(personalDataAsString).catch(e => result = e);

		if (result.status === 200) {
			sessionStorage.setItem("idProcesso", result.data.payload.idProcesso)
			await this.recoveryPasswordService.sendSmsToken();
			this.showNotificationSmsModal(result.data.payload);
		} else if (result.status === 406) {
			this.showProspectModal(result.status);
		} else if ([400, 401, 403, 404].contains(result.status)) {
			this.show40XNotificationModal(result.status);
		}

		this.loading = false;
		this.$scope.$apply();
	};

	/**
	 * 200 - Process Started Notification Modal
	 */
	showNotificationSmsModal(process) {
		let modalInstance = this.$uibModal.open({
			animation: true,
			templateUrl: 'notificationSms.modal.html',
			controllerAs: '$ctrl',
			size: "sm",
			controller: ($scope, process) => {
				"ngInject";
				let $ctrl = $scope.$ctrl;
				$ctrl.process = process;

				$ctrl.ok = () => modalInstance.close();
			},
			resolve: {
				process: () => process
			}
		});
		modalInstance.result.then(() => this.$state.go("tokenSms"));
	};

	/**
	 * 40X - Error Notification Modal
	 */
	show40XNotificationModal(code) {
		let modalInstance = this.$uibModal.open({
			animation: true,
			templateUrl: 'errorNotification.modal.html',
			controllerAs: '$ctrl',
			size: "sm",
			controller: ($scope, code) => {
				"ngInject";
				let $ctrl = $scope.$ctrl;

				$ctrl.code = code;
				$ctrl.ok = () => {
					modalInstance.close();
				};
			},
			resolve: {
				code: () => code
			}
		});
	};

	showProspectModal(code) {
		let modalInstance = this.$uibModal.open({
			animation: true,
			templateUrl: 'modalProspectEmAssociacao.modal.html',
			controllerAs: '$ctrl',
			size: "sm",
			controller: ($scope, code) => {
				"ngInject";
				let $ctrl = $scope.$ctrl;

				$ctrl.code = code;
				$ctrl.ok = () => {
					modalInstance.close();
				};
			},
			resolve: {
				code: () => code
			}
		});
	};

	renderTurnstile() {
		const tryRender = () => {
			const el = document.getElementById('turnstile-widget');
			if (typeof turnstile !== 'undefined' && el && el.childElementCount === 0) {
				turnstile.render(el, {
					sitekey: '0x4AAAAAABgoi_-GJRL4WzV_',
					callback: (token) => {
						this.captchaToken = token;
						this.$scope.$applyAsync();
					},
					'expired-callback': () => {
						this.captchaToken = null;
						this.$scope.$applyAsync();
					},
					'error-callback': () => {
						this.captchaToken = null;
						this.$scope.$applyAsync();
					}
				});
			} else {
				setTimeout(tryRender, 300);
			}
		};

		tryRender();
	}

}

export default LoginController;


// WEBPACK FOOTER //
// ./src/app/components/views/login/login.controller.js